export const EDIT_PROVIDER_PROFILE_DETAILS = {
  BSA_ID: "bsaId",
  FIRST_NAME: "firstName",
  LAST_NAME: "lastName",
  FULL_NAME: "fullName",
  EMAIL: "userEmail",
  CONTACT_NUMBER: "userNumber",
  GENDER: "gender",
  ROLE: "role",
  STATUS: "status",
};

export const TYPE_OF_GENDER = [
  { label: "Male", value: "male" },
  { label: "Female", value: "female" },
  { label: "Other", value: "Other" },
];
